import React, { useState } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({ breaks: true });

const EmailComposer = ({ initialDraft = {}, onClose = () => {}, onSent = () => {}, onError = () => {} }) => {
  const [draft, setDraft] = useState({
    uid: initialDraft.uid || '',
    to: initialDraft.to || '',
    subject: initialDraft.subject || '',
    body: initialDraft.body || ''
  });
  const [sending, setSending] = useState(false);

  const convert = (plain) => {
    const raw = marked.parse(plain || '');
    return DOMPurify.sanitize(raw, { SAFE_FOR_TEMPLATES: true });
  };

  const handleSend = async () => {
    if (!draft.to || !draft.subject) return onError('Recipient and subject required');
    setSending(true);
    try {
      const html = convert(draft.body);
      const resp = await fetch('/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid: draft.uid, to: draft.to, subject: draft.subject, html, from: initialDraft.from })
      });
      const j = await resp.json();
      if (j.need_reauth) {
        onError('Authorization required');
      } else if (j.sent) {
        onSent(j);
        onClose();
      } else {
        onError(j.error || 'Send failed');
      }
    } catch (err) {
      onError(err.message || 'Send failed');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded shadow-lg w-11/12 max-w-2xl p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold">Compose Email</h3>
          <button onClick={onClose} className="text-gray-600">Close</button>
        </div>

        <label className="block text-sm">To</label>
        <input className="w-full border p-2 rounded mb-2" value={draft.to} onChange={e => setDraft(d => ({ ...d, to: e.target.value }))} />

        <label className="block text-sm">Subject</label>
        <input className="w-full border p-2 rounded mb-2" value={draft.subject} onChange={e => setDraft(d => ({ ...d, subject: e.target.value }))} />

        <label className="block text-sm">Body (Markdown supported)</label>
        <textarea rows={10} className="w-full border p-2 rounded" value={draft.body} onChange={e => setDraft(d => ({ ...d, body: e.target.value }))} />

        <div className="mt-3 flex justify-end space-x-2">
          <button onClick={onClose} className="px-3 py-1 border rounded">Cancel</button>
          <button onClick={handleSend} disabled={sending} className="px-4 py-2 bg-indigo-600 text-white rounded">
            {sending ? 'Sending...' : 'Send'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailComposer;